import { ProductSelectionEditor, ProductFilterAllowedOptions } from 'app/pages/DiscountEditor/components/ProductSelection';
import { getAllProductsBasedOnCurrentSchool, getProductListState, getSelectedProductMissingSchoolHints } from 'app/pages/DiscountEditor/modules/ProductSelection';
import * as ProductFilter from 'app/shared/model/ProductFilter';
import { connect } from 'react-redux';
import {UnitsFilter, UnitsFilterType} from 'app/shared/model/ProductUnitFilter';

export interface StatefulSelectionEditorProps {
    productFilter?: ProductFilter.ProductFilter
    changeProductFilter: (newFilter: ProductFilter.ProductFilter) => void,
    unitFilter?: UnitsFilter
    changeUnitFilter?: (unitFilter: UnitsFilter) => void
    errorMessage?: string
    allowedFilterOption?: ProductFilterAllowedOptions
    allowUnitFilter?: boolean
}

const defaultProductFilter : ProductFilter.ProductFilter = {
    type: ProductFilter.ProductFilterType.AnyProduct
}

const defaultUnitsFilter  : UnitsFilter = {
    type: UnitsFilterType.None
}

function noop() {}

function mapStateToProps(state: any, ownProps: StatefulSelectionEditorProps) {
    const productFilter = ownProps.productFilter || defaultProductFilter;
    return {
        productFilter: productFilter,
        changeProductFilter: ownProps.changeProductFilter,
        unitFilter: ownProps.unitFilter || defaultUnitsFilter,
        changeUnitFilter: ownProps.changeUnitFilter||noop,

        allowUnitFilter: !!ownProps.allowUnitFilter,
        allowedFilterOption: ownProps.allowedFilterOption,
        errorMessage: ownProps.errorMessage,

        productOptions: getAllProductsBasedOnCurrentSchool(state, productFilter),
        productsListState: getProductListState(state, productFilter),
        productOfferingHints: getSelectedProductMissingSchoolHints(state, productFilter)
    };
}

export default connect(mapStateToProps)(ProductSelectionEditor);